// vue
import Vue from 'vue';
// bootstrap
import BootstrapVue from 'bootstrap-vue';
// Bug 66379: Terug draaien: Dashboard schuift niet goed in bij smaller scherm: import './styles/dashboard.scss';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './css/custom.css';
import './styles/appStyles.scss';
// progressbar
import 'nprogress/nprogress.css';
// applicatie imports
import App from './DashboardApp.vue';
import router from './router';
import store from './store';
// services
import nedglobeApi from './services/nedglobeapi';
import createPolygonService from './services/polygon';
import createSystemService from './services/system';

// Internationalization plugin
import i18n from './i18n';

Vue.config.productionTip = false;
const polygonService = createPolygonService(nedglobeApi);
const systemService = createSystemService();

Vue.use(BootstrapVue);

new Vue({
    router,
    store: store,

    // services
    nedglobeApi,
    polygonService,
    systemService,
    i18n,
    render: h => h(App)
}).$mount('#app');
